import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeletePolicyRuleModal = ({ show, onClose, onDelete }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Borrar regla')} size="m">
      <Styles.Container>
        <Text type="bodyMRegular">{t('Esta acción no se podrá deshacer. ¿Quieres continuar?')}</Text>
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <Button fullWidth onClick={onDelete}>
            {t('Aceptar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default DeletePolicyRuleModal
